import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import patchUser from 'Api/user/patchUser';
import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';

import upsertUserPayload from './model/request/upsertUserPayload';

const usePatchUser = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = upsertUserPayload(formData);

      const result = await patchUser({ payload, id: formData.id });

      return result;
    },
    onMutate: () => {
      onShowLoader({ variant: 'loader-primary' });
    },

    onSuccess: () => {
      onOpenToast({
        status: 'success',
        description: 'User berhasil diupdate',
        duration: 5,
        isClosable: true,
      });

      navigate(-1);
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.errors?.[0]?.message || 'Failed to update user';

      onOpenToast({
        status: 'error',
        title: 'Failed to update user',
        description: errorMessage,
        duration: 5,
        isClosable: true,
      });

      navigate(-1);
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePatchUser;
